export function getProductShareInfo(appName) {
  if (appName === "jjarchive") {
    return {
      logo: "jjarchive.png",
      android:
        "https://play.google.com/store/apps/details?id=com.daycatcher.jjarchive",
      ios: "https://apps.apple.com/kr/app/%EC%A7%A4%EC%B9%B4%EC%9D%B4%EB%B8%8C/id6464375270",
      title: "짤카이브",
      desc: "짤 관리는 짤카이브에서 !",
    };
  }
}
